<div class="">

  <div class="popup-inner-space">
    <div class="betweenheader">Assign Company</div>

    <div class="text-right flow-right">

      <img src="assets/images/close.svg" id="close" alt="..." class="img-fluid closeicon2 cursor-pointer" (click)="Close();" id="close-icon">

    </div>

  </div>
  <form [formGroup]="AssignCompanyForm" (ngSubmit)="AssignCompany()" id="AssignCompanyForm" class="popup-inner-space">
    <div class="sucessmsg padding-left15"><span *ngIf="successMsg">{{successMsg}}</span></div>
    <div class="errmsg padding-left15"><span *ngIf="errorMsg">{{errorMsg}}</span></div>
    <div class="padding-top-15 margin-bottom-13">
      <div class="fxg-field fxg-field2">
        <mat-form-field style="display:block;" id="AssignCompanyForm-select">
          <mat-select formControlName="CompanyId" (selectionChange)="OnChangeCompany($event)" class="fxg-field__select">
            <mat-option value="">(Select Company)</mat-option>
            <mat-option MatFormFieldControl="CompanyId" *ngFor="let lstcompany of CompanyList" [value]="lstcompany.CodeValue">
              {{lstcompany.CodeDisplayText}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div class="main-errormsg margin-left-10 font-size11" *ngIf="displayMessage">
          {{displayMessage.CompanyId}}
        </div>
      </div>
    </div>
    <div class="Cancelactionsection margin-top-20">
      <button id="Assign" class="btncommon btn-bg-blue" type="submit">Assign</button>
      <button id="Assign-cancel" class="btncommon btn-border" (click)="Close()">Cancel</button>
    </div>

  </form>
</div>